module.exports = __webpack_public_path__ + "static/media/claim_status.916cc651.jpg";